import { WHITE } from "../../consts/colors";

export const styles = {
  loginParentConatiner: {
    display: "flex",
    flexDirection: "column",
    marginTop: "100px",
    justifyContent: "space-between",
    flex: 1,
  },
  loginFormContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "0px",
  },
  copyRightsContainer: {
    marginBottom: "40px",
    maxWidth: "298px",
    alignSelf: "center",
  },
  copyRightText: {
    fontSize: "12px",
    color: WHITE,
    textAlign: "center",
  },
};
